import {
  canonicalReportingMonth,
  getReportingMonth,
  isEditableMonth,
  parseReportingMonth,
  type ReportingMonth,
} from './reportingMonth';

/** Same-tab reload only — new tab/window defaults to the calendar month. */
export const COMPLIANCE_HUB_SESSION_REPORTING_MONTH_KEY = 'complianceHub_sessionReportingMonth';

/** Legacy key (browser-wide); no longer read on open. */
export const COMPLIANCE_HUB_LEGACY_REPORTING_MONTH_KEY = 'complianceHub_lastReportingMonth';

export function resolveInitialComplianceHubReportingMonthDate(now: Date = new Date()): Date {
  try {
    if (typeof sessionStorage !== 'undefined') {
      const raw = sessionStorage.getItem(COMPLIANCE_HUB_SESSION_REPORTING_MONTH_KEY);
      if (raw?.trim()) {
        const canon = canonicalReportingMonth(raw.trim(), raw.trim() as ReportingMonth);
        if (isEditableMonth(canon, now)) {
          return parseReportingMonth(canon);
        }
      }
    }
  } catch {
    /* ignore */
  }
  return parseReportingMonth(getReportingMonth(now));
}

export function persistComplianceHubReportingMonthChoice(month: ReportingMonth): void {
  const canon = canonicalReportingMonth(month, month);
  try {
    sessionStorage.setItem(COMPLIANCE_HUB_SESSION_REPORTING_MONTH_KEY, canon);
  } catch {
    /* ignore */
  }
  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem(COMPLIANCE_HUB_LEGACY_REPORTING_MONTH_KEY);
    }
  } catch {
    /* ignore */
  }
}

/** Clear same-tab month memory (call on sign-out so the next login opens on the current month). */
export function clearComplianceHubSessionReportingMonth(): void {
  try {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.removeItem(COMPLIANCE_HUB_SESSION_REPORTING_MONTH_KEY);
    }
  } catch {
    /* ignore */
  }
}

/** One-time cleanup so an old global month choice does not confuse support checks. */
export function clearLegacyComplianceHubReportingMonthStorage(): void {
  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem(COMPLIANCE_HUB_LEGACY_REPORTING_MONTH_KEY);
    }
  } catch {
    /* ignore */
  }
}
